// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ZsMi","title":"Info_title__1WbPy","links":"Info_links__2Z18S","link":"Info_link__GmzsR","logo":"Info_logo__1lS-Y"};